export const init = () => {
    const accordionList = document.getElementById('js-accordion-product-list');
        if (accordionList) {
            const toggleButtons = document.querySelectorAll('.js-accordion-product-toggle-button');
            [...toggleButtons].map((button) => {
                button.onclick = () => {
                    button.classList.toggle('expanded');
                }
        })
    }
}